/**
 * Lightweight cross-app signal for plan / subscription changes. Any component
 * that shows plan, status, usage, or credits listens for BILLING_CHANGED and
 * refetches — so an upgrade, cancel, or resume propagates everywhere (sidebar,
 * feature gates, credit meter, billing page, pricing CTAs) without a page reload.
 *
 * Paired with focus/visibility refresh in AuthContext + useUsage, this covers
 * both in-app billing actions (broadcast) and returning from the Polar checkout
 * tab (focus refresh).
 */
export const BILLING_CHANGED = "ll:billing-changed";

export function notifyBillingChanged() {
  try {
    window.dispatchEvent(new Event(BILLING_CHANGED));
  } catch {
    /* no window (SSR/tests) — ignore */
  }
}
